<template>
  <div class="quiz-finish">
    <img src="@/assets/img/finish.png" alt="">
    <a
      href="https://a1solarstore.com/"
      target="_blank"
      class="quiz-btn"
    >
      Got it
    </a>
  </div>
</template>